export enum SoldTicketStatuses {
	None = 0,
	Validated = 1,
	PreReserved = 5,
	Archived = 6,
	ScannedIn = 7,
	Cancelled = 8,
}
